export default __webpack_public_path__ + "static/media/LOS_Tree_Icon_Gray.8a5fc1a4.svg";